import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/tab_img.jpg'
import _imports_1 from '../assets/get.png'
import _imports_2 from '../assets/ad.jpg'
import _imports_3 from '../assets/guize.png'
import _imports_4 from '../assets/guangdong/slogin.png'


const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "el_col" }
const _hoisted_3 = {
  class: "el_row",
  style: {"text-align":"left","width":"80%"}
}
const _hoisted_4 = { style: {"margin-left":"10px","color":"white"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_CustomDialog = _resolveComponent("CustomDialog")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createElementBlock("body", _hoisted_1, [
    _createVNode(_component_el_container, { class: "home2" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_main, { style: {"padding-top":"0"} }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _cache[10] || (_cache[10] = _createElementVNode("img", {
                src: _imports_0,
                alt: "logo",
                class: "img_title"
              }, null, -1)),
              _createVNode(_component_el_input, {
                class: "el_phone_input",
                type: "number",
                maxlength: "11",
                modelValue: _ctx.phone,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.phone) = $event)),
                placeholder: _ctx.input_phone_hinder,
                pattern: _ctx.pone_pattern,
                onFocus: _ctx.handleFocus
              }, null, 8, ["modelValue", "placeholder", "pattern", "onFocus"]),
              _createElementVNode("img", {
                src: _imports_1,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getGo())),
                class: "img"
              }),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_el_checkbox, {
                  onChange: _ctx.handleCheckChanged,
                  modelValue: _ctx.checked,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.checked) = $event)),
                  size: "large"
                }, null, 8, ["onChange", "modelValue"]),
                _createElementVNode("p", _hoisted_4, [
                  _cache[8] || (_cache[8] = _createTextVNode(" 我已阅读并同意", -1)),
                  _createElementVNode("strong", null, [
                    _createElementVNode("span", {
                      style: {"border-bottom":"rgba(255, 239, 0, 1) solid 1px"},
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.readInfo2()))
                    }, "《服务协议》"),
                    _cache[7] || (_cache[7] = _createTextVNode("及", -1)),
                    _createElementVNode("span", {
                      style: {"border-bottom":"rgba(255, 239, 0, 1) solid 1px"},
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.readInfo()))
                    }, "《隐私政策》")
                  ]),
                  _cache[9] || (_cache[9] = _createTextVNode("，知悉业务说明并用该号码登录办理 ", -1))
                ])
              ]),
              _cache[11] || (_cache[11] = _createElementVNode("div", { class: "el_row" }, [
                _createElementVNode("div", { style: {"background-color":"white","border-radius":"30px","margin-left":"30px","margin-right":"30px","margin-top":"0px","margin-bottom":"10px"} }, [
                  _createElementVNode("p", {
                    class: "font_size",
                    style: {"color":"black"}
                  }, [
                    _createTextVNode(" 开通咪咕悦看超级会员,"),
                    _createElementVNode("strong", { style: {"color":"rgba(255, 70, 15, 1)"} }, "标准资费20元/月"),
                    _createTextVNode("， 以"),
                    _createElementVNode("strong", { style: {"color":"rgba(255, 70, 15, 1)"} }, "话费支付"),
                    _createTextVNode("，具体以实际扣费为准， 支付成功后"),
                    _createElementVNode("strong", { style: {"color":"rgba(255, 70, 15, 1)"} }, "立即生效，有效期3年（36个自然月），如双方在有效期届满前无异议，有效期自动续展，每次续展3年。有效期内变更/退订/销户/携转，无需承担相应的违约责任。"),
                    _createTextVNode(" 可随时取消，取消"),
                    _createElementVNode("strong", { style: {"color":"rgba(255, 70, 15, 1)"} }, "立即生效"),
                    _createTextVNode(",当前周期内可继续享受权益，次月起不再扣费。 ")
                  ])
                ])
              ], -1)),
              _cache[12] || (_cache[12] = _createElementVNode("strong", { style: {"font-size":"20px","text-align":"center","color":"white"} }, "客服热线：4001009886", -1)),
              _cache[13] || (_cache[13] = _createElementVNode("img", {
                src: _imports_2,
                alt: "logo",
                class: "img_title"
              }, null, -1)),
              _cache[14] || (_cache[14] = _createElementVNode("div", {
                class: "el_col",
                style: {"color":"white","font-size":"18px","align-items":"flex-start","text-align":"left"}
              }, [
                _createElementVNode("img", {
                  src: _imports_3,
                  alt: "logo",
                  class: "img_title"
                }),
                _createElementVNode("img", {
                  src: _imports_4,
                  alt: "logo",
                  class: "img_title"
                })
              ], -1))
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_dialog, {
          modelValue: _ctx.centerDialogVisible,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.centerDialogVisible) = $event)),
          width: "500",
          "align-center": ""
        }, {
          default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
            _createElementVNode("div", { style: {"width":"100%","text-align":"left","font-size":"20px"} }, [
              _createElementVNode("p", null, "尊敬的客户："),
              _createElementVNode("p", null, "根据《中华人民共和国反恐怖主义法》、 《全国人民代表大会常务委员会关于加强网络信息保护的决定》、 《电信和互联网用户个人信息保护规定》（工业和信息化部令第24号）等国家法律法规的要求， 为更好地提供服务，需要客户提供如联系人、联系电话、通信地址、电子邮箱等信息。"),
              _createElementVNode("p", null, " 为向客户提供优质、个性化的服务，包括但不限于提供通信服务、 保障通信服务安全、改善服务质量、推介个性化产品等， 我公司将遵循合法、正当、必要的原则， 按照法律法规规定或协议约定使用留存客户个人信息， 并妥善保管，严格保密，依法保护客户个人信息。")
            ], -1)
          ]))]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_dialog, {
          modelValue: _ctx.serviceDialogVisible,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.serviceDialogVisible) = $event)),
          width: "500",
          style: {"height":"500px"},
          "align-center": ""
        }, {
          default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
            _createElementVNode("div", { style: {"width":"100%","text-align":"left","font-size":"20px","height":"450px","overflow":"auto"} }, [
              _createElementVNode("p", null, "尊敬的客户："),
              _createElementVNode("p", null, " 请您务必仔细阅读并了解本《服务协议》（以下简称为“服务协议”）。对于重要条款我们采用粗体及下划线方式进行显著标注以提示您注意。您一旦主动在页面填写您的个人信息并进行提交操作，即意味着您同意我们按照本声明收集、使用、共享您的相关信息。若您不接受本声明，请勿登记您的个人信息。我们的页面和服务主要面向成人。我们不会主动收集未成年人的个人信息，如果您未满18周岁，请您在监护人陪同下仔细阅读并充分理解本声明，并征得监护人的同意后使用我们的服务或向我们提供信息。"),
              _createElementVNode("p", null, "一、收集信息的原则及目的"),
              _createElementVNode("p", null, " 保障为您所提供的产品或服务功能的正常实现。2.实现对您的推送功能。3.帮助我们维护和改进我们的产品或服务，提升用户体验。"),
              _createElementVNode("p", null, "二、如何收集和使用您的个人信息"),
              _createElementVNode("p", null, "我们将合法合规对您的个人信息进行采集、使用。您已知晓并同意在您下次浏览本落地页面时，我们会帮您预先填写您上次输入的历史信息以提升您的使用体验。您亦可拒绝使用预填充功能。（一）收集和使用您的个人信息的范围 1.下单及订单管理 为了向您配送货物或提供相关服务，当您准备登记您的信息以促成交易的达成时，我们将相应收集您的姓名、手机号、地址、性别和身份证号码（仅特殊行业需要，如运营商、保脸）。同时，所涉订单中会鼓明订单编号、您所购买的商品或服务信息、下单时间等。具体需要填写的信息可能会根据我们提供的产品/服务的不同而有所差异，请以届时向您展示的产品/服务以及所对应的要求填写相关个人信息。2.广告的定向推送 为实现广告推送功能，在您进入本广告页面并同意本声明时，我们还可能会收集您的产品与/或服务的设备信息，包括网络身份标识信息（手机IPV4地址、IP）、网络信息、手机硬件信息（电量、品牌、型号、内存、屏幕分辨率、CPU信息）和运营商信息、操作日志。（二）例外 对于《信息安全技术个人信息安全规范》5.6中规定的情形，我们收集、使用您的个人信息无需事先征得您的授权同意。"),
              _createElementVNode("p", null, "三、如何共享、转让您的个人信息"),
              _createElementVNode("p", null, "（一）共享 仅为实现本声明之目的，我们可能会与关联公司、合作伙伴共享您的某些个人信息。对我们与之共享个人信息的公司、组织和个人，我们会与其签署严格的合规协定或做类似要求，以规范其处理个人信息的行为，并促使其具备个人信息的安全保障能力。我们将与以下授权合作伙伴共享您的信息：1.供应商、服务提供商和其他合作伙伴（包括相关代理商）。为向您进行货物配送及提供服务，我们可能会将您主动登记提供的信息向该商品及服务的提供商，以及为此目的所涉及的必要第三方进行共享，并由其在您已经向其授权的范围内使用，包括向您发送货物或与您进行必要的联系。2.广告、分析服务类的授权合作伙伴。我们可能会将您的匿名化或去标识化的个人信息及您的设备信息与广告、分析服务类的授权合作伙伴共享，以帮助其在不识别您的个人身份的前提下提升广告有效触达率。（二）转让 我们不会将您的个人信息转让给任何第三方，但基于您的明确同意或法律法规要求或涉及合并、收购、分立、重组或破产清算的情况除外。"),
              _createElementVNode("p", null, "四、如何保存与保护您的个人信息"),
              _createElementVNode("p", null, " 我们的信息保护规则：1.收集到您的个人信息后，在保障供应商、服务提供商和其他合作伙伴或必要第三方能够凭借相关信息进行货物发送或服务提供的基础上，我们将通过技术手段及时对数据进行匿名化或去标识化处。2.我们已使用符合业界标准的安全防护撸施保护您提供的个人信息，防止数据遭到未经授权访问、公开披露等。3.如果我们的管理防护设施遭到破坏，导致信息被非授权访问、公开披露、幕改或毁坏，我们将及时将事件相关情况及时向您告知，难以逐一告知时，我们会采取公告的方式。同时，我们还将主动上报个人信息安全事件的处置情况。我们的信息保存方式：1.保存期限：您提供的个人信息，将在上文所声明的服务提供过程中持续授权我们使用。在您删除个人信息时，我们将视为您撒回了对于该等个人信息收集、使用或共享的授权和同意。2.保存地域：原则上，我们所采集到的您的个人信息将存储在中国。"),
              _createElementVNode("p", null, "五、您对个人信息享有的权利"),
              _createElementVNode("p", null, " 按照中国相关的法律、法规、标准，我们保障您对自己的个人信息的更正权、删除权或授权撇回等相关权益。为实现本第五条所述权利，您可通过本声明第七条“如何联系我们”中所列明的联系方式与我们进行联系，我们在验证主体身份，确认相关要求和理由后，为您进行相应的更正、到除及授权撤回。"),
              _createElementVNode("p", null, "六、政策更新"),
              _createElementVNode("p", null, " 基于服务优化或情况变更等事由，本声明会不定期进行更新。更新版本将通过在官方网站、广告落地页面等我们正在运营或进行合作的各类相关产品中发出，也请您访问我们网站及软件以便及时了解最新的《服务协议》。"),
              _createElementVNode("p", null, "七、联系我们"),
              _createElementVNode("p", null, "您可通过广告落地页中的客服电话联系我们，我们将会在15个工作日内给您反馈。")
            ], -1)
          ]))]),
          _: 1
        }, 8, ["modelValue"]),
        (_ctx.showToast)
          ? (_openBlock(), _createBlock(_component_CustomDialog, {
              key: 0,
              close: _ctx.handColse
            }, null, 8, ["close"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}